import React, { useMemo, useState } from 'react';
import carData from '../../data/car.json';
import './CarClassification.css';

const CarClassification = () => {
  const [query, setQuery] = useState('');

  const classEntries = useMemo(
    () =>
      Object.entries(carData.car_classes).sort(
        ([leftClass], [rightClass]) => Number(leftClass) - Number(rightClass)
      ),
    []
  );

  const normalizedQuery = query.trim().toLowerCase();

  const filteredCars = useMemo(() => {
    if (!normalizedQuery) {
      return carData.cars;
    }

    return carData.cars.filter((car) => {
      const brand = car.brand.toLowerCase();
      const model = car.model.toLowerCase();
      return brand.includes(normalizedQuery) || model.includes(normalizedQuery);
    });
  }, [normalizedQuery]);

  const groupedCars = useMemo(() => {
    const grouped = classEntries.reduce((acc, [classId]) => {
      acc[classId] = [];
      return acc;
    }, {});

    filteredCars.forEach((car) => {
      grouped[String(car.class)]?.push(car);
    });

    return grouped;
  }, [classEntries, filteredCars]);

  return (
    <section className="car-classification">
      <div className="car-classification__inner">
        <div className="car-classification__hero">
          <p className="car-classification__eyebrow">Каталог классов</p>
          <h1 className="car-classification__title">Классификация машин</h1>
          <p className="car-classification__description">
            Подобрали для вас полный список автомобилей. Введите бренд или модель, чтобы быстро
            найти нужный класс.
          </p>
        </div>

        <div className="car-classification__search-wrap">
          <input
            type="text"
            className="car-classification__search"
            placeholder="Поиск по марке или модели"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
          />
          <p className="car-classification__search-note">
            Найдено: <strong>{filteredCars.length}</strong>
          </p>
        </div>

        <div className="car-classification__grid">
          {classEntries.map(([classId, classInfo]) => (
            <article className="car-classification__card" key={classId}>
              <div className="car-classification__card-head">
                <h2>{classInfo.label}</h2>
                <span>{groupedCars[classId].length}</span>
              </div>
              <p className="car-classification__class-description">{classInfo.description}</p>

              <div className="car-classification__models">
                {groupedCars[classId].length ? (
                  groupedCars[classId].map((car) => (
                    <p key={`${classId}-${car.brand}-${car.model}`} className="car-classification__model">
                      <strong>{car.brand}</strong>
                      <span>{car.model}</span>
                    </p>
                  ))
                ) : (
                  <p className="car-classification__empty">По вашему запросу в этом классе ничего не найдено.</p>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CarClassification;
